import { render, staticRenderFns } from "./AntiPassBack.vue?vue&type=template&id=fa4616b4&scoped=true"
import script from "./AntiPassBack.vue?vue&type=script&lang=js"
export * from "./AntiPassBack.vue?vue&type=script&lang=js"
import style0 from "./AntiPassBack.vue?vue&type=style&index=0&id=fa4616b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4616b4",
  null
  
)

export default component.exports